/**
 * External dependencies
 */
import React, { useState } from 'react';
import { connect } from 'react-redux';

/**
 * Internal dependencies
 */
import Button from 'components/button';
import { successNotice, errorNotice } from 'state/notices/actions';
import cecSdk from 'lib/customer-ec-sdk';
import JumpingDots from 'components/jumping-dots';

const ConnectionLocationApiButton = ({ connectionId, details, disabled, ...props }) => {
   
    const [location, setLocation] = useState(false);

    const locationConnection = async () => {
        setLocation(true);
        try {
            let { result } = await cecSdk.connection(connectionId).location({ connectionDetails: details });

            if (result) {
                props.successNotice('Imported!');
                window.location.reload(false);
            } else {
                props.errorNotice('Invalid request');
            }
        } catch (error) {
            props.errorNotice('Unknown error occoured.');
            console.log(error);
        }
        setLocation(false);
    };

    return (
        <Button disabled={disabled} onClick={locationConnection}>
            {location ? <div>Importing <JumpingDots /></div> : 'Import location'}
        </Button>
    );

};

export default connect(null, {
    successNotice,
    errorNotice,
})(ConnectionLocationApiButton);
